import React, { useEffect, useState, useRef } from 'react';

import "./AboutUs.scss";

import CountUp from 'react-countup';

import Testimonial from '../Components/Testimonial';
import CallAction from '../Components/CallAction';

import BgVd1 from "./../Images/bg1.gif";
import BgVd2 from "./../Images/bg2.gif";

import AbtImgw from "./../Images/about-img.webp";
import AbtImg from "./../Images/about-img.jpg";

import VluImg1w from "./../Images/value1.webp";
import VluImg1 from "./../Images/value1.png";
import VluImg2w from "./../Images/value2.webp";
import VluImg2 from "./../Images/value2.png";
import VluImg3w from "./../Images/value3.webp";
import VluImg3 from "./../Images/value3.png";
import VluImg4w from "./../Images/value4.webp";
import VluImg4 from "./../Images/value4.png";

import CeoImg1w from "./../Images/santhosh-sk2.webp";
import CeoImg1 from "./../Images/santhosh-sk2.jpg";
import CeoImg2w from "./../Images/sam-deva-anbu.webp";
import CeoImg2 from "./../Images/sam-deva-anbu.jpg";

import CrGridImg1w from "./../Images/cr-grid1.webp";
import CrGridImg1 from "./../Images/cr-grid1.jpg";
import CrGridImg2w from "./../Images/cr-grid2.webp";
import CrGridImg2 from "./../Images/cr-grid2.jpg";
import CrGridImg3w from "./../Images/cr-grid3.webp";
import CrGridImg3 from "./../Images/cr-grid3.jpg";

const VluList = [
  { srset1: VluImg1w, srset2: VluImg1, title: "Innovation & Imagination", para: "We push boundaries with bold ideas and transformative thinking to create meaningful change.", delay: "400" },
  { srset1: VluImg2w, srset2: VluImg2, title: "Integrity & Inclusion", para: "We uphold honesty, transparency, and a culture where every voice matters.", delay: "600" },
  { srset1: VluImg3w, srset2: VluImg3, title: "Excellence as a Standard", para: "We never settle. We deliver with precision, passion, and purpose.", delay: "800" },
  { srset1: VluImg4w, srset2: VluImg4, title: "Client-First Focus", para: "Every decision starts with our clients' understanding of their goals and delivering solutions that exceed expectations.", delay: "1000" },
]

const CeoList = [
  { srset1: CeoImg1w, srset2: CeoImg1, name: "Santhosh Kumar", desig: "Founder" },
  { srset1: CeoImg2w, srset2: CeoImg2, name: "Sam Deva Anbu M S", desig: "Director" },
]

const CrGridList = [
  { srset1: CrGridImg1w, srset2: CrGridImg1, clss: "grid1", iWdth: "756" },
  { srset1: CrGridImg2w, srset2: CrGridImg2, clss: "grid2", iWdth: "350" },
  { srset1: CrGridImg3w, srset2: CrGridImg3, clss: "grid3", iWdth: "350" },
]

export default function AboutUs() {
  useEffect(() => {
    const handleResize = () => {
      setTimeout(() => {
        var i = 0;
        var set = 0;
        var cols = document.querySelectorAll("[data-col]");
        var encountered = [];
        for (i = 0; i < cols.length; i++) {
          var attr = cols[i].getAttribute("data-col");
          if (encountered.indexOf(attr) === -1) {
            encountered.push(attr);
          }
        }
        for (set = 0; set < encountered.length; set++) {
          var col = document.querySelectorAll(
            '[data-col="' + encountered[set] + '"]'
          );
          var group = [];
          for (i = 0; i < col.length; i++) {
            col[i].style.height = "auto";
            var elementHeight = col[i].offsetHeight;
            group.push(elementHeight);
          }
          for (i = 0; i < col.length; i++) {
            col[i].style.height = "auto";
            col[i].style.height = Math.max.apply(Math, group) + "px";
          }
        }
      }, 100);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
  }, []);

  const overviewRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setInView(true);
          }, 1000);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    if (overviewRef.current) {
      observer.observe(overviewRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className='banner2 banner-about'>
        <div className='video-bg1'><img src={BgVd1} alt='' /></div>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-lg-9 col-18 banner2-lt-ct mb-lg-0' data-col="eq-ht" data-aos="fade-down" data-aos-once='true'>
              <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                <tbody>
                  <tr>
                    <td valign='bottom'>
                      <p className='f-18 txt-lg-lt txt-center line-ht-24 mb-3'>Power up your brand voice and connect with the audience that matters.</p>
                      <h2 className='fw-300 txt-lg-lt txt-center'>Cut through the noise, create what truly matters.</h2>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='col-lg-9 col-18 banner2-rt-ct mb-0' data-col="eq-ht">
              <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                <tbody>
                  <tr>
                    <td valign='bottom'>
                      <div className='mxw-350 col-12 ms-lg-0 m-auto mb-5 float-none' data-aos="fade-left" data-aos-once='true' data-aos-delay="400">
                        <picture>
                          <source srcSet={AbtImgw} type="image/webp" />
                          <source srcSet={AbtImg} type="image/png" />
                          <img src={AbtImg} alt="About Us" title="About Us" width="500" height="500" />
                        </picture>
                      </div>
                      <p className='f-18 txt-lg-lt txt-center line-ht-24 mb-0' data-aos="fade-up" data-aos-once='true' data-aos-delay="400">At ZYX Media, we don't just market brands, we craft stories that resonate. Through strategy, imagination, and authentic connections, we transform ideas into lasting impact.</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className='video-bg2'><img src={BgVd2} alt='' /></div>
      </div>
      <div className='about-info-cont bg-pattern' ref={overviewRef}>
        <div className='container-fluid sectin'>
          <ul className='row'>
            <li className='col-xl-2 col-18 mb-0' data-aos="fade-right" data-aos-once='true'>
              <div className='aic-1'>
                <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                  <tbody>
                    <tr>
                      <td valign='bottom'>
                        <p className='f-20 txt-white fw-600 mb-0 line-ht-24'><span className='f-20 txt-white fw-600 mb-0 line-ht-24 d-xl-blk'>We're</span> storytellers who have your back</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className='aic-2'>
                <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                  <tbody>
                    <tr>
                      <td valign='middle'>
                        <p className='h1 fw-600 mb-0'>{inView && <CountUp className='h1 fw-600 mb-0 d-in-blk fw-300' start={0} end={10} />}+</p>
                        <p className='f-20 fw-600 mb-0 line-ht-24'>Years of experiences</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
            <li className='col-xl-7 col-sm-9 col-18 aic-3' data-aos="fade-up" data-aos-once='true' data-aos-delay="400">
              <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                <tbody>
                  <tr>
                    <td valign='bottom'>
                      <p className='f-20 txt-white fw-600 mb-4 line-ht-24'>We put people at the heart of every creation, weaving emotion with intention to craft work that engages, inspires, and propels your brand forward with purpose.</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </li>
            <li className='col-xl-7 col-sm-9 col-18 aic-4' data-aos="fade-down" data-aos-once='true' data-aos-delay="600">
              <p className='f-20 txt-white fw-600 mb-0 line-ht-24'>Your vision isn't just a project — it's our passion.</p>
            </li>
            <li className='col-xl-7 col-md-9 col-18 mb-0' data-aos="fade-left" data-aos-once='true' data-aos-delay="800">
              <div className='aic-5 f-20 txt-white fw-600 mb-0 line-ht-24'>We turn your brand story into bold, creative experiences.</div>
              <div className='aic-6'>
                <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                  <tbody>
                    <tr>
                      <td>
                        <p className='h1 fw-600 mb-0'>{inView && <CountUp className='h1 fw-600 mb-0 d-in-blk fw-300' start={0} end={20} />}k+</p>
                        <p className='f-20 fw-600 mb-0 line-ht-24'>happy clients</p>
                      </td>
                    </tr>
                    <tr>
                      <td valign='bottom'><div className='btn-outline f-18 mb-0'>Let's Create Together</div></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className='clear'></div>
            </li>
          </ul>
        </div>
      </div>
      <div className='values-cont'>
        <div className='container-fluid sectin pb-4'>
          <div className='row'>
            <div className='col-lg-8 col-18'>
              <h2 className='h1 fw-300 mb-1 txt-lt' data-aos="fade-down" data-aos-once='true'>Purpose-led.</h2>
              <h2 className='h1 fw-300 mb-1 txt-lt' data-aos="fade-down" data-aos-once='true'>People-focused.</h2>
              <h2 className='h1 fw-300 mb-8 txt-lt' data-aos="fade-down" data-aos-once='true'>Excellence-driven.</h2>
              <div className='mxw-450' data-aos="fade-up" data-aos-once='true' data-aos-delay="400"><p className='f-18 mb-8 line-ht-24'>We are guided by integrity and fueled by innovation, collaboration, and an unwavering pursuit of impact.</p></div>
            </div>
            <div className='col-lg-10 col-18 mb-0'>
              <ul className='row'>
                {VluList.map((item, index) => {
                  return (
                    <li key={index} className='col-xl-9 col-lg-18 col-sm-9 col-18' data-aos="fade-left" data-aos-once='true' data-aos-delay={item.delay} data-col="eq-ht2">
                      <div className='value-icon mb-4'>
                        <picture>
                          <source srcSet={item.srset1} type="image/webp" />
                          <source srcSet={item.srset2} type="image/png" />
                          <img src={item.srset2} alt={item.title} title={item.title} width="64" height="64" />
                        </picture>
                      </div>
                      <h6 className="h9 fw-400 mb-4">{item.title}</h6>
                      <div className='clear'></div>
                      <p className="f-18 mb-0 line-ht-24">{item.para}</p>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Testimonial />
      <div className='about-msg' data-aos="fade-up" data-aos-once='true'>
        <div className='container-fluid sectin'>
          <div className='mxw-1100 m-auto sectin'>
            <p className='h8 txt-white-60 txt-center mb-0'>We build with heart, work with purpose, and move with faith. It's not just about growing fast it's about growing right. With hustle, clarity, and belief, we're here to conquer, one meaningful step at a time.</p>
          </div>
        </div>
      </div>
      <div className='team-cont bg-pattern'>
        <div className='container-fluid sectin pb-6'>
          <h2 className='h1 fw-300 mb-8 txt-lg-center txt-lt' data-aos="fade-down" data-aos-once='true'>Meet our Founders</h2>
          <ul className='mxw-800 m-auto'>
            {CeoList.map((item, index) => {
              return (
                <li key={index} data-aos="fade-up" data-aos-once='true'>
                  <div className='tpro-ct m-auto p-rel'>
                    <div className='tpro-img'>
                      <picture>
                        <source srcSet={item.srset1} type="image/webp" />
                        <source srcSet={item.srset2} type="image/jpg" />
                        <img src={item.srset2} alt={item.name} title={item.name} width="350" height="500" />
                      </picture>
                    </div>
                    <div className='tpro-dts'>
                      <h6 className='f-16 fw-600 txt-white mb-0'>{item.name}</h6>
                      <p className='mb-0'>{item.desig}</p>
                    </div>
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
      <div className='team-cont bg-pattern'>
        <div className='container-fluid sectin pb-6'>
          <h2 className='h1 fw-300 mb-8 txt-lg-center txt-lt' data-aos="fade-down" data-aos-once='true'>It's our Creative Grid</h2>
          <div className='mxw-700 m-lg-auto txt-lg-center txt-lt mb-8' data-aos="fade-down" data-aos-once='true'><p className='f-18 mb-0 line-ht-24'>At ZYX Media, we blend creativity and technology to elevate your brand's story. Let us help you engage your audience & achieve your business goals.</p></div>
          <ul className='mxw-800 m-auto'>
            {CrGridList.map((item, index) => {
              return (
                <li key={index} data-aos="fade-up" data-aos-once='true' className={item.clss}>
                  <div className='tpro-ct m-auto p-rel'>
                    <div className='tpro-img'>
                      <picture>
                        <source srcSet={item.srset1} type="image/webp" />
                        <source srcSet={item.srset2} type="image/jpg" />
                        <img src={item.srset2} alt='Creative Grid' title='Creative Grid' width={item.iWdth} height="500" />
                      </picture>
                    </div>
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
      <CallAction />
    </>
  )
}
